module.exports = __webpack_public_path__ + "static/salt1-b3efce760098c11bcfb05ff414438d81.png";